const pinnigLimit = 10;
const recentLimit = 5;
// eslint-disable-next-line no-unused-vars
const merge = (a, b, p) => a.filter(aa => !b.find(bb => aa[p] === bb[p])).concat(b);

export const getUserReports = state => state.userData.userReports;
export const getUserType = state => state.userData.userType;

export const getDashboardProps = state => ({
  ...state.dashboard,
  activeTab: state.dashboard.activeTab ? state.dashboard.activeTab : state.userData.launchPage,
});

export const getReportCategoryFilters = state =>
  getUserReports(state)
    .map(group => ({
      value: group.name,
      label: group.name,
      children: group.reportCategories
        .filter(rc =>
          (rc.reportsWithMainCategoryReference && rc.reportsWithMainCategoryReference.length) ||
          (rc.reportsWithoutMainCategoryReference && rc.reportsWithoutMainCategoryReference.length))
        .map(category => ({
          value: category.name,
          label: category.name,
        })),
    }));

export const getReportCategories = state =>
  getUserReports(state)
    .map(group => group.reportCategories)
    .reduce((a, b) => a.concat(b), [])
    .filter(rc =>
      (rc.reportsWithMainCategoryReference && rc.reportsWithMainCategoryReference.length) ||
      (rc.reportsWithoutMainCategoryReference && rc.reportsWithoutMainCategoryReference.length))
    .map(rc => ({
      ...rc,
      reports: rc.reportsWithMainCategoryReference.filter(report => report.showOnLaunchPage),
    }));

export const getFilteredReportCategories = (state) => {
  const { selectedCategoryFilters } = state.dashboard;
  const reportCategories = getReportCategories(state);

  let returnObject = reportCategories;
  if (state.dashboard.keyword) {
    returnObject = reportCategories
      .map(reportCategory => ({
        ...reportCategory,
        reports: reportCategory.reports.filter(report => report.name.toLowerCase().indexOf(state.dashboard.keyword.toLowerCase()) > -1),
        reportsWithMainCategoryReference: reportCategory.reportsWithMainCategoryReference.filter(report => report.name.toLowerCase().indexOf(state.dashboard.keyword.toLowerCase()) > -1),
        reportsWithoutMainCategoryReference: reportCategory.reportsWithoutMainCategoryReference.filter(report => report.name.toLowerCase().indexOf(state.dashboard.keyword.toLowerCase()) > -1),
      }));
  }

  if (selectedCategoryFilters.length > 0) {
    const reportsBySelectedCategoryMap = returnObject
      .filter(reportCategory => selectedCategoryFilters.includes(reportCategory.name))
      .map((reportCategory) => {
        const reportsWithMainCategoryReference = reportCategory.reportsWithMainCategoryReference
          .filter(report => report.reportLevel === 1)
          .map(report => ({
            reportCode: report.reportCode,
            mainCategory: report.mainReportCategoryName,
          }));
        const reportsWithoutMainCategoryReference = reportCategory.reportsWithoutMainCategoryReference
          .filter(report => report.reportLevel === 1)
          .map(report => ({
            reportCode: report.reportCode,
            mainCategory: report.mainReportCategoryName,
          }));
        const reportsOfCategory = new Set([...reportsWithMainCategoryReference, ...reportsWithoutMainCategoryReference]);
        return {
          category: reportCategory.name,
          reports: reportsOfCategory,
        };
      });

    const reportCodesOfUnion = new Set([]);
    const reportsOfUnion = new Set([]);
    reportsBySelectedCategoryMap.forEach((selectedCategoryWithReport) => {
      selectedCategoryWithReport.reports.forEach((report) => {
        if (!reportCodesOfUnion.has(report.reportCode)) {
          reportsOfUnion.add(report);
          reportCodesOfUnion.add(report.reportCode);
        }
      });
    });

    let reportsOfIntersection = Array.from(reportsOfUnion);
    reportsBySelectedCategoryMap.forEach((selectedCategoryWithReport) => {
      reportsOfIntersection = reportsOfIntersection
        .filter(reportFromIntersection => Array.from(selectedCategoryWithReport.reports).map(report => report.reportCode).includes(reportFromIntersection.reportCode));
    });

    const distinctMainCategoriesFiltered = new Set([]);
    reportsOfIntersection.forEach(report => distinctMainCategoriesFiltered.add(report.mainCategory));

    const distinctReportCodesFiltered = new Set([]);
    reportsOfIntersection.forEach(report => distinctReportCodesFiltered.add(report.reportCode));

    returnObject = returnObject
      .filter(reportCategory => distinctMainCategoriesFiltered.has(reportCategory.name))
      .map(reportCategory => ({
        ...reportCategory,
        reports: reportCategory.reports.filter(report => distinctReportCodesFiltered.has(report.reportCode)),
      }));
  }
  return returnObject.filter(rc => rc.reports && rc.reports.length);
};

export const getPinnedReports = state =>
  getReportCategories(state)
    .map(rc => rc.reports)
    .reduce((a, b) => a.concat(b), [])
    .filter(report => report.pinned);

export const getSavedReports = state =>
  getReportCategories(state)
    .map(rc => rc.reports)
    .reduce((a, b) => a.concat(b), [])
    .filter(report => report.saved && report.saved.length)
    .map(report => report.saved.map(saved => ({
      ...report,
      saved: {
        id: saved.id,
        reportCode: report.reportCode,
        selectionName: saved.selectionName,
        ...JSON.parse(saved.requestBody),
      },
    })))
    .reduce((a, b) => a.concat(b), []);

export const getRecentReports = state =>
  getReportCategories(state)
    .map(rc => rc.reports)
    .reduce((a, b) => a.concat(b), [])
    .filter(report => report.recent)
    .map(report => ({
      ...report,
      recent: {
        id: report.recent.id,
        reportCode: report.reportCode,
        ...JSON.parse(report.recent.requestBody),
      },
    }))
    .reduce((a, b) => a.concat(b), [])
    .sort((a, b) => b.recent.createTime - a.recent.createTime)
    .slice(0, recentLimit);

export const canPerformPinning = state =>
  getPinnedReports(state).length < pinnigLimit;
